<template>
  <div class="maskBox">
    <div class="topWinner" :style="{'backgroundImage':'url('+require('../../assets/images/cashWheel/topWinnerBg.webp')+')'}">
      <div class="title">{{replaceWinNum($t('lang.cashWheel.successfullyTotal'))}}</div>
      <div :class="lang==='EN'?'won':'wonIN'">{{$t('lang.cashWheel.won')}}</div>
      <div class="bubbleLanguage">{{$t('lang.cashWheel.bubbleLanguage')}}</div>
      <div class="titleBar">{{$t('lang.cashWheel.topWinner')}}</div>
      <img class="userIcon" :src="randomUser?randomUser.userImg:''" alt="">
      <img class="userIcon2" :src="randomUser?randomUser.userImg:''" alt="">
      <div class="tryBtn" :style="{ backgroundImage: 'url(' + require('../../assets/images/cashWheel/btnBg.png') + ')' }" @click="goTry()">{{$t('lang.cashWheel.try')}}</div>
    </div>
  </div>
</template>

<script>
import { userDataList } from './userData'
export default {
  name: 'modal-topWinner',
  data () {
    return {
      randomUser: null,
      userDataList: userDataList,
      lang: localStorage.getItem('locale')
    }
  },
  mounted () {
    this.getRandomUser()
  },
  watch: {
    '$store.state.locale': function (val) {
      this.lang = val
    }
  },
  methods: {
    getRandomUser () {
      const randomIndex = Math.floor(Math.random() * this.userDataList.length)
      this.randomUser = this.userDataList[randomIndex]
    },
    replaceWinNum (val) {
      return val.replace('{WinNum}', this.getRandomNumber(1200, 2000))
    },
    getRandomNumber (min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min
    },
    goTry () {
      this.$emit('closeMoadlTopWinner')
    }
  }
}
</script>

<style lang="less" scoped>
@keyframes expandBox {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.maskBox{
  height: 100vh;
  width: 100%;
  position: fixed;
  background-color: rgba(0,0,0,0.8);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.topWinner{
  background-size: 100% 100%;
  height: 96.094vw;
  width: 93.736vw;
  position: relative;
  top: -15vw;
  left:  -0.5vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  transform-origin: center;
  animation: expandBox 0.2s ease-in-out forwards;
  backdrop-filter: blur(5px);
  .title{
    width: 77.77vw;
    height: 15vw;
    font-size: 5.27vw;
    color: #fff;
    font-weight: 700;
    position: absolute;
    top: -18vw;
    left: 7vw;
    text-align: center;
    line-height: 7vw;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    text-align: center;
    text-transform: capitalize;
    background: linear-gradient(90deg, #F3F396 0%, #8CEBE3 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
  }
  .won{
    position: absolute;
    color: #FFFFFF;
    font-size: 5.277vw;
    font-weight: 700;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
    top: 58vw;
    left: 31vw;
  }
  .wonIN{
    position: absolute;
    color: #FFFFFF;
    font-size: 5.277vw;
    font-weight: 700;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
    top: 57.5vw;
    left: 28vw;
  }
  .bubbleLanguage{
    position: absolute;
    top: 75vw;
    left: 26vw;
    color: #fff;
    font-size: 3.285vw;
    width: 55.38vw;
    height: 10vw;
    line-height: 5vw;
  }
  .titleBar{
    font-size: 4.72vw;
    font-weight: 800;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64.83vw;
    height: 9.28vw;
    position: relative;
    top: 5.5vw;
    font-family: 'Inter';
    font-style: normal;
    /* identical to box height, or 95% */
    text-transform: capitalize;
    color: #E6FFCE;
  }
  @keyframes shrinkAndDrop {
    0% {
      width: 200vw; /* 初始宽度特别大 */
      height: 200vw; /* 初始高度特别大 */
      top: 0; /* 初始位置 */
      opacity: 0; /* 初始不透明度为0 */
    }
    50% {
      opacity: 1; /* 中间阶段完全可见 */
    }
    100% {
      height: 21.4vw;
      width: 21.4vw;
      top: 30.5vw; /* 最终位置 */
      opacity: 1; /* 完全不透明 */
    }
  }
  @keyframes shrinkAndDrop2 {
    0% {
      height: 13.61vw;
      width: 13.61vw;
      left: -20vw;
      top: 73vw;
    }
    100% {
      height: 13.61vw;
      width: 13.61vw;
      top: 73vw; /* 最终位置 */
      left: 6vw;
      opacity: 1; /* 完全不透明 */
    }
  }
  .userIcon2{
    position: absolute;
    border-radius: 15vw;
    //top: -14vw;
    animation-name: shrinkAndDrop2;
    animation-duration: 0.3s;
    animation-timing-function: ease-out;
    animation-fill-mode: forwards;
    left: 0;
  }
  .userIcon{
    height: 21.4vw;
    width: 21.4vw;
    position: absolute;
    border-radius: 15vw;
    //top: -14vw;
    animation-name: shrinkAndDrop;
    animation-duration: 0.4s;
    animation-timing-function: ease-out;
    animation-fill-mode: forwards;
  }
  .tryBtn{
    height: 10.83vw;
    width: 81.913vw;
    border-radius: 2.22vw;
    background-size: 100% 100%;
    color: #000;
    font-weight: 700;
    font-size: 4.44vw;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    top: 15vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cashWheel/modal-topWinner.vue